import { FormikProps } from 'formik'
import React from 'react'

export const CurrentFormikContext = React.createContext<FormikProps<any>>(
  null as any
)
